import { render } from "./PlanStep6.vue?vue&type=template&id=08730bb0"
import script from "./PlanStep6.vue?vue&type=script&lang=js"
export * from "./PlanStep6.vue?vue&type=script&lang=js"

import "./PlanStep6.vue?vue&type=style&index=0&id=08730bb0&lang=stylus"

import exportComponent from "F:\\OneDrive\\Рабочий стол\\cleancutmeals\\cleancutmeals\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__